import { groups } from 'features/Insurance/groups';
import offers from 'features/Insurance/offers';
import { Group } from 'features/Insurance/types';

import { InsurancesCoverage, OfferByGroups } from './types';

export const getOffersByGroup = (coverage: InsurancesCoverage) => {
  return Object.entries(groups).reduce<OfferByGroups>(
    (acc, [groupKey, group]) => {
      acc.set(groupKey as Group, {
        ...group,
        offers: group.offers.map((name) => ({
          ...offers[name],
          isCovered: coverage[name].isCovered,
          isCoveredFromPlan: coverage[name].isCoveredFromPlan,
        })),
      });

      return acc;
    },
    new Map() as OfferByGroups,
  );
};
